import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button" ]

  connect() {
    // Toggle Password Visibility
    this.buttonTarget.addEventListener('click', () => {
        const element = this.element.querySelector('input')
        element.type = element.type == "text" ? "password" : "text"
    });
  }
}
